import React, { useCallback, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { generatePath, useLocation, useNavigate, useParams } from 'react-router-dom';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';
import ListPage from '@components/common/layout/ListPage';
import PageWrapper from '@components/common/layout/PageWrapper';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { getData, setData } from '@utils/localStorage';
import { Button, Modal, Tabs } from 'antd';

import KitplaySettingSavePage from '../../../../components/common/page/kitplaySetting/KitplaySettingSavePage';

import Device from './Device';
import GeneralSaveBase from './GeneralSaveBase';
import GroupArea from './GroupArea';
import GroupDevice from './GroupDevice';

import styles from '../../index.module.scss';

const DeviceTab = () => {
    const translate = useTranslate();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const searchParams = new URLSearchParams(location.search);
    const generalFormRef = useRef(null);
    const mysqlFormRef = useRef(null);
    const groupDeviceRef = useRef(null);
    const deviceId = searchParams.get('deviceId');
    const deviceName = searchParams.get('deviceName');
    const collapseId = searchParams.get('collapseId');

    const [activeTab, setActiveTab] = useState(
        getData(routes.DeviceTab.keyActiveTab)
            ? getData(routes.DeviceTab.keyActiveTab)
            : translate.formatMessage(commonMessage.Device),
    );
    const [groupDeviceDirty, setGroupDeviceDirty] = useState(false);

    const confirmIfDirty = useCallback((action, contentMessage) => {
        if (groupDeviceDirty) {
            Modal.confirm({
                title: translate.formatMessage(commonMessage.unsavedChangesContent),
                content: contentMessage || '',
                okText: translate.formatMessage(commonMessage.continue),
                cancelText: translate.formatMessage(commonMessage.cancel),
                centered: true,
                onOk: () => {
                    setGroupDeviceDirty(false);
                    action();
                },
            });
        } else {
            action();
        }
    }, [groupDeviceDirty]);

    const handleCreateClick = () => {
        confirmIfDirty(() => doCreateNavigation());
    };

    const doCreateNavigation = () => {
        if (activeTab === 'device') {
            const currentPath = location.pathname.replace('group-device', 'device-child');
            const searchParams = location.search;
            const createLink = `${currentPath}/create${searchParams}`;
            navigate(createLink);
        } else if (activeTab === 'group-device') {
            const currentPath = location.pathname;
            const searchParams = location.search;
            const createLink = `${currentPath}/create${searchParams}`;
            navigate(createLink);
        } else if (activeTab === 'area') {
            const currentPath = location.pathname.replace('group-device', 'area');
            const searchParams = location.search;
            const createLink = `${currentPath}/create${searchParams}`;
            navigate(createLink);
        }
    };

    const handleUpdateClick = () => {
        if (activeTab === 'setting-device' && generalFormRef.current) {
            generalFormRef.current.submit();
        }
        if (activeTab === 'mysql' && mysqlFormRef.current) {
            mysqlFormRef.current.submit();
        }
    };

    return (
        <PageWrapper
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.managerKitplay),
                    path: collapseId ? `${routes.listKitPlayDevicePage.path}?collapseId=${collapseId}` : routes.listKitPlayDevicePage.path,
                },
                { breadcrumbName: deviceName },
            ]}
        >
            <ListPage
                baseTable={
                    <>
                        <Tabs
                            type="card"
                            destroyInactiveTabPane
                            onTabClick={(key) => {
                                if (key === activeTab) return;
                                confirmIfDirty(() => {
                                    setActiveTab(key);
                                    setData(routes.DeviceTab.keyActiveTab, key);
                                }, translate.formatMessage(commonMessage.unsavedSwitchTab));
                            }}
                            activeKey={activeTab}
                            items={[
                                {
                                    key: 'area',
                                    label: translate.formatMessage(commonMessage.area),
                                    children: <GroupArea />,
                                },
                                {
                                    key: 'device',
                                    label: translate.formatMessage(commonMessage.childDevice),
                                    children: <Device />,
                                },
                                {
                                    key: 'group-device',
                                    label: translate.formatMessage(commonMessage.workflow),
                                    children: (
                                        <GroupDevice ref={groupDeviceRef} onDirtyChange={setGroupDeviceDirty} />
                                    ),
                                },
                                {   
                                    key: 'setting-device',
                                    label: translate.formatMessage(commonMessage.setting),
                                    children: <KitplaySettingSavePage deviceId={deviceId}/>,
                                },
                                // {
                                //     key: 'mysql',
                                //     label: translate.formatMessage(commonMessage.mysqlSetting),
                                //     children: <GeneralSaveBase formRef={mysqlFormRef} type="mysql" />,
                                // },
                            ]}
                        />
                    </>
                }
            />
        </PageWrapper>
    );
};

export default DeviceTab;
